import { cn } from '@/lib/cn';
import { initialsOf } from '@/lib/format';

export interface AvatarProps {
  name: string;
  className?: string;
}

export function Avatar({ name, className }: AvatarProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'grid size-8 shrink-0 place-items-center rounded-full text-[11px] font-extrabold text-on-avatar',
        'bg-[linear-gradient(135deg,var(--color-avatar-from),var(--color-avatar-to))]',
        className,
      )}
    >
      {initialsOf(name)}
    </span>
  );
}
